<template>
  <div class="mx-md-12 px-sm-12 text-center">
    <p class="display-1 primary--text text-center">Kurzzeitpflege</p>

    <p class="text-justify">
      Kurzzeitpflege kann in unserem Haus bei freien Ressourcen vereinbart werden.
      Grundsätzlich sind alle unsere 78 Plätze für die Langzeitpflege vorgesehen. <br>
      <a
      href="https://www.pflegeinfo-ooe.at/unterst%C3%BCtzung-in-der-pflege-und-betreung/pflege-und-betreuung-zu-hause/kurzzeitpflege"
      target="blank"
      >
        Nähere Informationen finden Sie hier.
      </a>
    </p>

    <img
    class="hidden-sm-and-down"
    width="50%"
    :src="require('@/assets/Angebote/Kurzzeitpflege/Salatpflanzen_setzen.jpg')"
    />

    <img
    class="hidden-md-and-up"
    width="100%"
    :src="require('@/assets/Angebote/Kurzzeitpflege/Salatpflanzen_setzen.jpg')"
    />

  </div>
</template>

<script>
  export default {
    name: 'kurzzeitpflege',
  }
</script>
